import styled from 'styled-components';

import { BREAKPOINTS } from "../../../app/appConstants";

export const VerifyPageWrapperStyled = styled.div`
    background-color: var(--color-surface);
    width: 100%;
`;

export const VerifyWrapperStyled = styled.div`
    padding: 32px 40px;
    max-width: 1024px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    @media (max-width: ${BREAKPOINTS.small}px) {
        padding: 32px 8px;
    }
`;

export const VerifyHeaderContainer = styled.div`
    text-align: center;
    max-width: 624px;
    margin: 0 auto;
    @media (max-width: ${BREAKPOINTS.medium}px) {
        max-width: unset;
    }
`;

export const VerifyComponentStyled = styled.div`
    height: 100%;
    padding: 24px;
    border: 1px solid var(--color-main);
    border-radius: 8px;
`

export const VerifyComponentsWrapper = styled.div`
    margin-top: 64px;
    margin-bottom: 32px;
    @media (max-width: ${BREAKPOINTS.small}px) {
        margin-top: 32px;
    }
`;

export const ContainerStyled = styled.div`
    margin: -8px;
    display: flex;
    flex-wrap: wrap;
`;

export const ColStyled = styled.div`
    padding: 8px;
    flex: 1;
    box-sizing: border-box;
`;

export const VerifyDocColStyled = styled(ColStyled)`
    flex-basis: 25%;
    @media (max-width: ${BREAKPOINTS.medium}px) {
        flex-basis: 100%;
    }
`;

export const VerifyDividerColStyled = styled(ColStyled)`
    flex: 0 0 40px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    @media (max-width: ${BREAKPOINTS.medium}px) {
        flex-basis: 100%;
    }
`;

export const VerifyDocIconStyled = styled.div`
    background-color: var(--color-surface-secondary);
    padding: 8px;
    border-radius: 8px;
    display: inline-block;
    margin-right: 16px;
`;

export const SubHeaderStyled = styled.h4`
    font-size: 20px;
    line-height: 28px;
    font-weight: 800;
    margin-bottom: 0;
    @media (max-width: ${BREAKPOINTS.extraLarge}px) {
        font-weight: 700;
        font-size: 18px;
        line-height: 26px;
    }
    @media (max-width: ${BREAKPOINTS.medium}px) {
        font-size: 16px;
        line-height: 22px;
    }
`;

export const VerifyComponentHeaderStyled = styled(SubHeaderStyled)`
    margin: 16px 0;
    @media (max-width: ${BREAKPOINTS.extraLarge}px) {
        margin-bottom: 8px;
    }
`;

export const VerifyDividerStyled = styled(SubHeaderStyled)`
    color: var(--color-main);
`;

export const VerifyAccordionListStyled = styled.ol`
    margin-bottom: 0;
    padding: 0 0 0 17px;
    color: var(--text-color-secondary);
    li {
        max-width: 620px;
        padding-left: 16px;
        &::marker {
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
        }
        &:not(:last-child) {
            margin-bottom: 24px;
        }
        @media (max-width: ${BREAKPOINTS.medium}px) {
            padding-left: 8px;
        }
    }
`;

export const VerifyAccordionMarkerStyled = styled.div`
    display: inline-block;
    width: 32px;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
`;

export const VerifyMiniatureDocContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: -8px;
    @media (max-width: 630px) {
        flex-direction: column;
    }
`;

export const VerifyMiniatureDocColStyled = styled.div`
    padding: 8px;
    display: flex;
`;

export const VerifyFooterContainer = styled.div`
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    margin-top: 32px;
    
    & > a {
        max-width: 334px;
        width: 100%;
        border-radius: 4px;
        font-size: 20px;
        line-height: 26px;
        padding: 10px;
        @media (max-width: ${BREAKPOINTS.medium}px) {
            font-size: 18px;
            line-height: 24px;
        }
        @media (max-width: ${BREAKPOINTS.small}px) {
            font-size: 16px;
            line-height: 20px;
            max-width: unset;
        }
    }
    
    & > span {
        max-width: 300px;
        text-align: right;
        @media (max-width: ${BREAKPOINTS.small}px) {
            max-width: unset;
            text-align: center;
        }
    }
`;

export const VerifyDescriptionStyled = styled.span`
    color: var(--text-color-secondary);
    font-size: 14px;
    line-height: 21px;
`;
